'use strict';

var reactIs_production_min = {};

exports.__exports = reactIs_production_min;
//# sourceMappingURL=react-is.production.min.cjs.map
